import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { Icon } from '../icon/icon';

@Component({
  selector: 'lib-dark-mode-toggle',
  imports: [Icon],
  templateUrl: './dark-mode-toggle.html',
  styleUrl: './dark-mode-toggle.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DarkModeToggle {
  public readonly isDark = model<boolean>(false);

  protected toggleDarkMode(): void {
    this.isDark.update((value) => !value);
  }

  protected toggleDarkModeEvent(event: Event): void {
    const isDark = (event.target as HTMLInputElement).checked;
    this.isDark.set(isDark);
  }
}
